import { cn } from "@/lib/utils";

interface SquircleProps {
  src: string;
  alt: string;
  size?: number;
  className?: string;
}

export function Squircle({ src, alt, size = 64, className }: SquircleProps) {
  return (
    <div
      className={cn(
        "relative overflow-hidden shadow-lg",
        className
      )}
      style={{
        width: size,
        height: size,
        borderRadius: `${size * 0.2237}px`, // Apple's squircle formula approximation
        boxShadow: '0 4px 16px rgba(0,0,0,0.1)',
      }}
    >
      <img
        src={src}
        alt={alt}
        className="w-full h-full object-cover"
        style={{
          borderRadius: `${size * 0.2237}px`,
        }}
        onError={(e) => {
          // Fallback to a placeholder if image fails to load
          const target = e.target as HTMLImageElement;
          target.src = `data:image/svg+xml,${encodeURIComponent(`
            <svg xmlns="http://www.w3.org/2000/svg" width="${size}" height="${size}" viewBox="0 0 ${size} ${size}">
              <rect width="100%" height="100%" fill="#f3f4f6"/>
              <text x="50%" y="50%" font-family="Arial, sans-serif" font-size="${size * 0.15}" text-anchor="middle" dy="0.3em" fill="#6b7280">
                ${alt.charAt(0).toUpperCase()}
              </text>
            </svg>
          `)}`;
        }}
      />
    </div>
  );
}